import React, { createContext, useContext, useState, useEffect } from 'react';
import { isAuthenticated, getStoredUser } from 'action/loginAction';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticatedState, setIsAuthenticatedState] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        const userData = getStoredUser();
        
        if (token && userData) {
          setUser(userData);
          setIsAuthenticatedState(true);
        } else {
          setUser(null);
          setIsAuthenticatedState(false);
        }
      } catch (error) {
        setUser(null);
        setIsAuthenticatedState(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = (userData, token) => {
    try {
      if (userData) {
        const remember = !!localStorage.getItem('token');
        const storageRef = remember ? localStorage : sessionStorage;
        storageRef.setItem('user', JSON.stringify(userData));
      }
    } catch (e) {
    }
    setUser(userData);
    setIsAuthenticatedState(true);
  };

  const logout = async () => {
    try {
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      localStorage.removeItem('user');
      sessionStorage.removeItem('user');
      
      setUser(null);
      setIsAuthenticatedState(false);
    } catch (error) {
      setUser(null);
      setIsAuthenticatedState(false);
    }
  };

  const updateUser = (userData) => {
    setUser(userData);
    try {
      const remember = !!localStorage.getItem('token');
      const storageRef = remember ? localStorage : sessionStorage;
      storageRef.setItem('user', JSON.stringify(userData));
    } catch (e) {}
  };

  const value = {
    user,
    isLoading,
    isAuthenticated: isAuthenticatedState,
    login,
    logout,
    updateUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
